import { getMagnitude } from "aible";

export default function getMagnitudeDiff(n1, n2) {
  return Math.abs(getMagnitude(n1) - getMagnitude(n2));
}
